<template>
  <CRow>
    <CCol col="12" lg="12">
      <CCard v-if="form">
        <CCardBody>
          <h3>
            Edit Decoration
          </h3>
          <CAlert
            :show.sync="dismissCountDown"
            color="primary"
            fade
          >
            ({{dismissCountDown}}) {{ message }}
          </CAlert>
          <CInput label="Decoration Name" type="text" placeholder="Name" v-model="form.decoration_name"></CInput>
          <CInput label="Customer Number" type="text" placeholder="Name" v-model="form.customer_number"></CInput>
          <CInput label="Quantity" type="number" placeholder="Name" v-model="form.min_quantity"></CInput>
          <CInput label="Cost" type="text" placeholder="Name" v-model="form.cost"></CInput>
          <CInput label="Lead Time" type="text" placeholder="Name" v-model="form.lead_time"></CInput>
          <div style="width:100%;float:left;">
            <label>Locations</label>
            <multiselect
              v-if="locations" 
              v-model="form.locations" 
              :options="locations" 
              :multiple="true" 
              label="location_name" 
              track-by="location_id"
            />
          </div>
          <div style="width:100%;float:left;margin-top:15px;">
            <CButton color="primary" @click="update()">Save</CButton>
            <CButton color="bg-gray-100" class="ml-2" @click="goBack">Back</CButton>
          </div>
          <div style="width:100;float:left;height:50px;margin-top:15px;">
            <CAlert
              :show.sync="dismissCountDown"
              color="primary"
              fade
            >
              ({{dismissCountDown}}) {{ message }}
            </CAlert>
          </div>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import Multiselect from 'vue-multiselect'
var methods = {}

methods.goBack = function () {
  this.$router.go(-1)
}

methods.getStyle = function () {
  let self = this;
  axios.get(   this.$apiAdress + '/api/decorations/edit?token=' + localStorage.getItem("api_token") + '&id=' + self.$route.params.id)
  .then(function (response) {
      // self.name = response.data.menulist.name;
      self.form = response.data.res
      self.locations = response.data.locations
      // self.decorations = response.data.decorations
      console.log(response)
  }).catch(function (error) {
      console.log(error);
      // self.$router.push({ path: '/login' });
  });
}

methods.update = function () {
  let self = this;
  console.log(this.form)
  axios.post(   this.$apiAdress + '/api/decorations/update' + '?token=' + localStorage.getItem("api_token"), self.form)
  .then(function (response) {
      self.message = 'Successfully updated this style.';
      self.showAlert();
  }).catch(function (error) {
      if(error.response.data.message == 'The given data was invalid.'){
        self.message = '';
        for (let key in error.response.data.errors) {
          if (error.response.data.errors.hasOwnProperty(key)) {
            self.message += error.response.data.errors[key][0] + '  ';
          }
        }
        self.showAlert();
      }
  });
}

methods.showAlert = function () {
  this.dismissCountDown = this.dismissSecs
}

export default {
  name: 'EditStyle',
  data: () => {
    return {
        form: null,
        message: '',
        dismissSecs: 3,
        dismissCountDown: 0,
        colors: null
    }
  },
  components: {
    Multiselect
  },
  methods: methods,
  mounted: function(){
    this.getStyle()
  }
}


</script>
